<template>
  <div>
    <pc-header :isTransparent.sync="isTransparent"></pc-header>

    <div class="product">
      <div class="left">
        <div v-for="(item, index) in list" :key="index">
          <div
            class="title"
            :class="item.isShow ? 'active' : 'text'"
            @click="onChangProduct(index)">
            {{ item.name }}
          </div>
        </div>
      </div>

      <div class="right">
        <div class="main-thumb">
          <div v-for="(item, index) in list[index].main_thumb" :key="index">
            <img :src="item.thumb" alt />
            <text>{{ item }}</text>
          </div>
        </div>
        <div v-for="(item, index) in list[index].thumb" :key="index">
          <img :src="item.thumb" alt />
          <text>{{ item }}</text>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pcHeader from "@/components/pcHeader"

export default {
  metaInfo: {
    title: "产品|东阳光冬虫夏草官网",
    meta: [
      {
        name: "keywords",
        content: "关键字"
      },
      {
        name: "description",
        content: "网页描述"
      }
    ]
  },
  components: {
    "pc-header": pcHeader
  },
  data() {
    return {
      isTransparent: true, // 是否透明
      list:[
        {
          isShow: true,
          name: '东阳光原草',
          main_thumb: [
            { thumb: require("@/assets/product-raw-grass-main-thumb-01.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-main-thumb-02.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-main-thumb-03.jpg"), alt: "" },
          ],
          thumb: [
            { thumb: require("@/assets/product-raw-grass-01.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-02.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-03.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-04.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-05.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-06.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-07.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-08.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-09.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-10.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-11.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-12.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-13.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-14.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-15.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-16.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-17.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-18.jpg"), alt: "" },
            { thumb: require("@/assets/product-raw-grass-19.jpg"), alt: "" }
          ]
       },
       {
          isShow: false,
          name: '东阳光鲜草',
          main_thumb: [
            { thumb: require("@/assets/produce-fresh-grass-main-thumb-01.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-main-thumb-02.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-main-thumb-03.jpg"), alt: "" },
          ],
          thumb: [
            { thumb: require("@/assets/produce-fresh-grass-01.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-02.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-03.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-04.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-05.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-06.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-07.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-08.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-09.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-10.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-11.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-12.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-13.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-14.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-15.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-16.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-17.jpg"), alt: "" },
            { thumb: require("@/assets/produce-fresh-grass-18.jpg"), alt: "" }
         ]
       },
       {
          isShow: false,
          name: '东阳光干鲜草',
          main_thumb: [
            { thumb: require("@/assets/producr-dried fresh-grass-main-thumb-01.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-main-thumb-02.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-main-thumb-03.jpg"), alt: "" },
          ],
          thumb: [
            { thumb: require("@/assets/producr-dried fresh-grass-01.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-02.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-03.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-04.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-05.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-06.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-07.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-08.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-09.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-10.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-11.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-12.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-13.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-14.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-15.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-16.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-17.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-18.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-19.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-20.jpg"), alt: "" },
            { thumb: require("@/assets/producr-dried fresh-grass-21.jpg"), alt: "" }
          ]
        },
        {
          isShow: false,
          name: 'HEC牌冬虫夏草 纯粉胶囊',
          main_thumb: [
            { thumb: require("@/assets/product-pure-powder-capsule-main-thumb-01.jpg"), alt: "" },
            { thumb: require("@/assets/product-pure-powder-capsule-main-thumb-02.jpg"), alt: "" },
            { thumb: require("@/assets/product-pure-powder-capsule-main-thumb-03.jpg"), alt: "" },
          ],
          thumb: [
            { thumb: require("@/assets/product-pure-powder-capsule-01.jpg"), alt: "" },
            { thumb: require("@/assets/product-pure-powder-capsule-02.jpg"), alt: "" },
            { thumb: require("@/assets/product-pure-powder-capsule-03.jpg"), alt: "" },
            { thumb: require("@/assets/product-pure-powder-capsule-04.jpg"), alt: "" },
            { thumb: require("@/assets/product-pure-powder-capsule-05.jpg"), alt: "" },
            { thumb: require("@/assets/product-pure-powder-capsule-06.jpg"), alt: "" },
            { thumb: require("@/assets/product-pure-powder-capsule-07.jpg"), alt: "" },
            { thumb: require("@/assets/product-pure-powder-capsule-08.jpg"), alt: "" },
            { thumb: require("@/assets/product-pure-powder-capsule-09.jpg"), alt: "" },
            { thumb: require("@/assets/product-pure-powder-capsule-10.jpg"), alt: "" },
            { thumb: require("@/assets/product-pure-powder-capsule-11.jpg"), alt: "" },
            { thumb: require("@/assets/product-pure-powder-capsule-12.jpg"), alt: "" }
          ]
        },
        {
          isShow: false,
          name: 'HEC牌冬虫夏草 经典复方胶囊',
          main_thumb: [
            { thumb: require("@/assets/product-compound-capsule-main-thumb-01.jpg"), alt: "" },
            { thumb: require("@/assets/product-compound-capsule-main-thumb-02.jpg"), alt: "" },
            { thumb: require("@/assets/product-compound-capsule-main-thumb-03.jpg"), alt: "" },
          ],
          thumb: [
            { thumb: require("@/assets/product-compound-capsule-01.jpg"), alt: "" },
            { thumb: require("@/assets/product-compound-capsule-02.jpg"), alt: "" },
            { thumb: require("@/assets/product-compound-capsule-03.jpg"), alt: "" },
            { thumb: require("@/assets/product-compound-capsule-04.jpg"), alt: "" },
            { thumb: require("@/assets/product-compound-capsule-05.jpg"), alt: "" },
            { thumb: require("@/assets/product-compound-capsule-06.jpg"), alt: "" },
            { thumb: require("@/assets/product-compound-capsule-07.jpg"), alt: "" },
            { thumb: require("@/assets/product-compound-capsule-08.jpg"), alt: "" },
            { thumb: require("@/assets/product-compound-capsule-09.jpg"), alt: "" },
            { thumb: require("@/assets/product-compound-capsule-10.jpg"), alt: "" }
          ]
        }
      ],
      index: 0
    }
  },
  methods: {
    /**
     * 事件绑定 - 改变产品
     *
     * @params index 索引
     * @return {void}
     */
    onChangProduct (index) {
      this.list.forEach((item, indexs) => {
        item.isShow = false 
      })

      this.index = index
      this.list[index].isShow = true
      let top = document.documentElement.scrollTop || document.body.scrollTop
      document.body.scrollTop = document.documentElement.scrollTop =  0
    }
  }
}
</script>

<style scoped lang="stylus">
.product{
  margin-top: 50px;
  font-size: 16px;
  width: 100%;
  display: flex;
  justify-content: center;

  .left{
    width: 169px;
    position: fixed;
    left: 10%;
  }

  .title{
    text-align: center;
    padding: 10px 15px;
    color: #FFF;
  }

  .active{
    background: #4087FC;
  }

  .text{
    background: rgba(0, 0, 0, 1);
    opacity: 0.9;
  }

  .right{
    width: 950px;

    .main-thumb {
      width: 950px;
      padding-left: 50px;
      padding:0px 10px;
      display: flex;
      justify-content: center;

      div {
        width: 252px;
        height: 252px;
        display: flex;
        margin: 10px 20px 98px 20px;
        border:1px solid #F2F2F2;

        img{
          width: 100%;
          height: 100%;
        }
      }
    }

    div {
      width: 950px;
      margin-top: -5px;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}  
</style>


// WEBPACK FOOTER //
// pcProduct.vue